module.exports = __webpack_public_path__ + "img/first04.241cafb5.png";